import React, { useEffect, useState } from 'react';
import { getFirestore, collection, query, onSnapshot, orderBy, where } from "firebase/firestore";
import app from './firebase';
import WallpaperItemAdvanced from './WallpaperItemAdvanced';

const INITIAL_ALBUM_OPTIONS = [
  "ABSTRACT", "ANIMALS", "ARTISTIC", "BLACK AND WHITE", "CARS", "CARTOONS",
  "CHAOS", "COLORFUL", "COMICS", "FLORAL", "FRIGHTFUL COMICS", "GAME ZONE",
  "GRAFFITI", "GRUNGE POSTERS", "HALLOWEEN", "HOLIDAYS", "LOVE", "MUSIC",
  "NATURE", "NEON ART", "POPASTIC", "PSYCHEDELIC", "SAYINGS", "SKULLS",
  "SPACE", "SPORT", "SUMMER", "SURREAL", "SYNTHWAVE", "VIBES", "WINTER",
  "NEW YEAR", "MINIMAL", "AESTHETIC", "CYBERPUNK", "DARK MODE", "RETRO",
  "LOCK SCREEN", "CHRISTMAS", "TWIN PINKS", "AMOLED", "DREAMLIKE", "MONEY",
  "WHIMSICAL", "FOR KIDS", "CATS", "DOGS", "NEON FRAMES", "INDUSTRIAL",
  "GOOD NIGHT", "EASTER", "SPRING", "AUTUMN"
];

function DraftWallpapers() {
  const [wallpapers, setWallpapers] = useState([]);
  const [allAlbums, setAllAlbums] = useState(INITIAL_ALBUM_OPTIONS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const db = getFirestore(app);
    const q = query(
      collection(db, "wallpapers"),
      where("status", "!=", "done"),
      orderBy("status")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        items.push({ id: doc.id, ...doc.data() });
      });
      setWallpapers(items);
      setLoaded(true);
    });

    return () => unsubscribe();
  }, []);

  const addAlbumGlobal = (newAlbum) => {
    const trimmed = newAlbum.trim();
    if (trimmed && !allAlbums.includes(trimmed)) {
      setAllAlbums(prev => [...prev, trimmed]);
    }
  };

  const removeWallpaperFromList = (idToRemove) => {
    setWallpapers(prev => prev.filter(wp => wp.id !== idToRemove));
  };

  return (
    <div style={{ margin: 30 }}>
      <h2>Draft Wallpapers</h2>
      {!loaded ? (
        <p>Loading...</p>
      ) : wallpapers.length === 0 ? (
        <p>No draft wallpapers found.</p>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
          {wallpapers.map((wp) => (
            <div key={wp.id} style={{ flex: '0 0 calc(50% - 20px)' }}>
              <WallpaperItemAdvanced
                wallpaper={wp}
                allAlbums={allAlbums}
                addAlbumGlobal={addAlbumGlobal}
                onSavedAsDone={() => removeWallpaperFromList(wp.id)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DraftWallpapers;
